import { Star } from "lucide-react";
import { productos } from "../data/db/Products";
import useCartStore from "../context/CartStore";
import { Link } from "react-router-dom";

const FeaturedProducts = () => {
  const featuredProducts = productos.filter((p) => p.isFeatured).slice(0, 6);
  const addToCart = useCartStore((state) => state.addToCart);

  return (
    <section id="FeaturedProducts" className="py-16 bg-gradient-to-b from-main-bg to-white px-4">
      <div className="max-w-7xl mx-auto">
        {/* Título con animación */}
        <div className="text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-dark mb-4 relative inline-block">
            Productos Destacados
            <div className="absolute -bottom-2 left-1/2 transform -translate-x-1/2 w-24 h-1 bg-primary rounded-full" />
          </h2>
          <p className="text-lg text-dark/80 max-w-2xl mx-auto">
            Tecnología médica de última generación seleccionada cuidadosamente para profesionales
          </p>
        </div>

        {/* Grid de productos */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {featuredProducts.map((producto, index) => (
            <div
              className="bg-white rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 overflow-hidden group"
            >
              {/* Link para la tarjeta */}
              <Link to={`/producto/${producto.id}`} className="block">
                <div className="relative">
                  <img
                    src={`${producto.imagenes[0]}`}
                    alt={`Imagen del producto ${producto.titulo}`}
                    className="w-full h-60 object-contain object-center"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-dark/40 to-transparent" />
                  <div className="absolute bottom-4 left-4 flex items-center">
                    <div className="flex text-yellow-400">
                      {[...Array(5)].map((_, i) => (
                        <Star key={i} className={`w-5 h-5 ${i < producto.rating ? "fill-current" : ""}`} />
                      ))}
                    </div>
                  </div>
                </div>

                <div className="p-6">
                  <h3 className="text-xl font-semibold text-dark mb-2">{producto.titulo}</h3>
                  <p className="text-sm text-dark/70 mb-4 line-clamp-2">{producto.descripcion}</p>
                </div>
              </Link>

              {/* Sección de precio y botón */}
              <div className="p-6">
                <div className="flex justify-between items-center">
                  <div>
                    <span className="text-2xl font-bold text-primary">${producto.precio}</span>
                    {producto.descuento > 0 && (
                      <span className="ml-2 text-sm line-through text-dark/50">
                        ${producto.precio + producto.descuento}
                      </span>
                    )}
                  </div>

                  <button type="button"
                    onClick={() =>
                      addToCart(
                        {
                          id: producto.id,
                          titulo: producto.titulo,
                          categoria: producto.categoria,
                          precio: producto.precio,
                          cantidad: 1,
                          stock: producto.stock,
                        },
                        1
                      )
                    }
                    className="bg-primary text-white px-4 py-2 rounded-lg flex items-center gap-2 transition-all"
                    aria-label={`Agregar ${producto.titulo} al carrito`}
                  >
                    <span>Agregar</span>
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Botón para ver más productos */}
        <div
          
          className="mt-12 text-center"
        >
          <Link to="/products">
            <button type="button"
              className="bg-dark text-white px-8 py-3 rounded-full hover:bg-opacity-90 transition-all"
            >
              Ver Todos los Productos
            </button>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default FeaturedProducts;
